// *** STORAGE SERVICE ***

// STORAGE URL
export const STORAGE_URL = process.env.VUE_APP_STORAGE_URL;
